import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import pickGlobalElementProps from 'utils/pickInputElementProps';
import * as React from 'react';
import Text from 'components/Text';
import tooltipable from 'lib/tooltipable';
import { MouseEventHandler } from "types/typescript/eventHandlers";

import './styles/Token.scss';

type TokenColor = 'default' | 'lava' | 'grey' | 'white';

type Props = {
  color?: TokenColor;
  disabled?: boolean;
  removable?: boolean;
  truncate?: boolean;
  onRemove?: MouseEventHandler;
  className?: string;
  children?: React.ReactNode;
};

type DefaultProps = {
  color: TokenColor;
  removable: boolean;
  truncate: boolean;
};

class Token extends React.Component<Props> {
  static propClasses = {
    color: {
      lava: 'Token--lava',
      grey: 'Token--grey',
      white: 'Token--white',
    },
  };

  static defaultProps: DefaultProps = {
    color: 'default',
    removable: true,
    truncate: true,
  };

  renderRemove = () => {
    const { disabled, onRemove, removable } = this.props;

    if (!removable || disabled) {
      return null;
    }

    return (
      <Link className="Token-remove" eventElementName="Token-remove" onClick={onRemove}>
        <Glyph name="close" size="xxsmall" solo />
      </Link>
    );
  };

  render() {
    const { children, className, disabled, truncate, ...others } = this.props;
    const otherProps = pickGlobalElementProps(others);

    // TODO: is `token` `className` casing purposeful?
    return (
      <div
        {...otherProps}
        className={cx('token', getPropClassesFromInstance(this), className, {
          'Token--disabled': disabled,
        })}>
        <Text truncate={truncate} className="Token-value">
          {children}
        </Text>
        {this.renderRemove()}
      </div>
    );
  }
}

export default tooltipable(Token);
